import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VeiculoSensor } from "src/app/models/VeiculoSensor.model";
import { VwSensor } from "src/app/models/VwSensor.model";
import { EventEmitterSensorService } from "src/app/services/event-emitter-sensor.service";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import Swal from "sweetalert2";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId, findIncompleteSensorRows, alertIncompleteTpmsRows } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-eight-dual",
  templateUrl: "./axle-eight-dual.component.html",
  styleUrls: ["./axle-eight-dual.component.scss"],
})
export class AxleEightDualComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() sensoresDisponiveis: any;
  @Input() veiculoId: number;

  @Output() atualizarSensores = new EventEmitter<void>();

  public sensorEightIntLeftSelect: any = [];
  public sensorEightIntRightSelect: any = [];

  public sensorEightExtLeftSelect: any = [];
  public sensorEightExtRightSelect: any = [];

  public sensorEightIntRightCombo: any = [];
  public sensorEightIntLeftCombo: any = [];

  public sensorEightExtRightCombo: any = [];
  public sensorEightExtLeftCombo: any = [];

  public axisEightDoubleLeftIntForm: FormGroup;
  public axisEightDoubleLeftExtForm: FormGroup;
  public axisEightDoubleRightIntForm: FormGroup;
  public axisEightDoubleRightExtForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private serviceApiBase: ApiBaseService,
    private componentResetService: EventEmitterSensorService
  ) {}

  ngOnInit(): void {
    this.componentResetService.reiniciarComponentes$.subscribe(async (a) => {
      this.sensoresDisponiveis = null;
      this.veiculoSensores = null;
      this.sensorEightExtRightCombo = [];
      this.sensorEightExtLeftCombo = [];
      this.sensorEightIntRightCombo = [];
      this.sensorEightIntLeftCombo = [];

      const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();

      const eixo = await this.serviceApiBase.get<any>({
        url: new VeiculoSensor()["nomeConsultaApiBase"] + this.veiculoId,
      });

      this.veiculoSensores = eixo["content"] ?? [];

      const sensor = await this.serviceApiBase.get<any>({
        url:
          new VwSensor()["nomeConsultaApiBaseSensor"] +
          this.veiculoId +
          "/perfil/" +
          perfil,
      });

      this.sensoresDisponiveis = sensor;

      if (this.sensoresDisponiveis.length > 0) {
        this.sensoresDisponiveis.forEach((element) => {
          this.sensorEightExtRightCombo.push(element);
          this.sensorEightExtLeftCombo.push(element);
          this.sensorEightIntRightCombo.push(element);
          this.sensorEightIntLeftCombo.push(element);
        });
      }

      this.loadSensor();
    });
    this.axisEightDoubleLeftIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisEightDoubleLeftExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisEightDoubleRightIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisEightDoubleRightExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    if (this.sensoresDisponiveis.length > 0) {
      this.sensoresDisponiveis.forEach((element) => {
        this.sensorEightExtRightCombo.push(element);
        this.sensorEightExtLeftCombo.push(element);
        this.sensorEightIntRightCombo.push(element);
        this.sensorEightIntLeftCombo.push(element);
      });
    }

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisEightDoubleLeftIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 8 ESQ INT"
      );
      this.axisEightDoubleLeftExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 8 ESQ EXT"
      );

      this.axisEightDoubleRightIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 8 DIR INT"
      );
      this.axisEightDoubleRightExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 8 DIR EXT"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo8DireitoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          18
        );
        const eixo8EsquerdoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          17
        );
        const eixo8DireitoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          34
        );
        const eixo8EsquerdoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          33
        );

        // EIXO 8 DIREITO EXTERNO
        if (eixo8DireitoExt != null) {
          this.axisEightDoubleRightExtForm.controls["id"].setValue(
            eixo8DireitoExt.id
          );

          if (eixo8DireitoExt.sensor != null) {
            appendSensorToCombo(this.sensorEightExtRightCombo, eixo8DireitoExt.sensor);
            this.sensorEightExtRightSelect = eixo8DireitoExt.sensor.id;
          }

          if (eixo8DireitoExt.pneu != null) {
            this.axisEightDoubleRightExtForm.controls["pneu"].setValue(
              eixo8DireitoExt.pneu.numeroFogo
            );
          }

          this.axisEightDoubleRightExtForm.controls["nrPressaoMinima"].setValue(
            eixo8DireitoExt.nrPressaoMinima
          );

          this.axisEightDoubleRightExtForm.controls["nrPressaoMaxima"].setValue(
            eixo8DireitoExt.nrPressaoMaxima
          );

          this.axisEightDoubleRightExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo8DireitoExt.nrTemperaturaMaxima);
        }

        // EIXO 8 ESQUERDO EXTERNO
        if (eixo8EsquerdoExt != null) {
          this.axisEightDoubleLeftExtForm.controls["id"].setValue(
            eixo8EsquerdoExt.id
          );

          if (eixo8EsquerdoExt.sensor != null) {
            appendSensorToCombo(this.sensorEightExtLeftCombo, eixo8EsquerdoExt.sensor);
            this.sensorEightExtLeftSelect = eixo8EsquerdoExt.sensor.id;
          }

          if (eixo8EsquerdoExt.pneu != null) {
            this.axisEightDoubleLeftExtForm.controls["pneu"].setValue(
              eixo8EsquerdoExt.pneu.numeroFogo
            );
          }

          this.axisEightDoubleLeftExtForm.controls["nrPressaoMinima"].setValue(
            eixo8EsquerdoExt.nrPressaoMinima
          );

          this.axisEightDoubleLeftExtForm.controls["nrPressaoMaxima"].setValue(
            eixo8EsquerdoExt.nrPressaoMaxima
          );

          this.axisEightDoubleLeftExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo8EsquerdoExt.nrTemperaturaMaxima);
        }

        // EIXO 8 DIREITO INTERNO
        if (eixo8DireitoInt != null) {
          this.axisEightDoubleRightIntForm.controls["id"].setValue(
            eixo8DireitoInt.id
          );

          if (eixo8DireitoInt.sensor != null) {
            appendSensorToCombo(this.sensorEightIntRightCombo, eixo8DireitoInt.sensor);
            this.sensorEightIntRightSelect = eixo8DireitoInt.sensor.id;
          }

          if (eixo8DireitoInt.pneu != null) {
            this.axisEightDoubleRightIntForm.controls["pneu"].setValue(
              eixo8DireitoInt.pneu.numeroFogo
            );
          }

          this.axisEightDoubleRightIntForm.controls["nrPressaoMinima"].setValue(
            eixo8DireitoInt.nrPressaoMinima
          );

          this.axisEightDoubleRightIntForm.controls["nrPressaoMaxima"].setValue(
            eixo8DireitoInt.nrPressaoMaxima
          );

          this.axisEightDoubleRightIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo8DireitoInt.nrTemperaturaMaxima);
        }

        // EIXO 8 ESQUERDO INTERNO
        if (eixo8EsquerdoInt != null) {
          this.axisEightDoubleLeftIntForm.controls["id"].setValue(
            eixo8EsquerdoInt.id
          );

          if (eixo8EsquerdoInt.sensor != null) {
            appendSensorToCombo(this.sensorEightIntLeftCombo, eixo8EsquerdoInt.sensor);
            this.sensorEightIntLeftSelect = eixo8EsquerdoInt.sensor.id;
          }

          if (eixo8EsquerdoInt.pneu != null) {
            this.axisEightDoubleLeftIntForm.controls["pneu"].setValue(
              eixo8EsquerdoInt.pneu.numeroFogo
            );
          }

          this.axisEightDoubleLeftIntForm.controls["nrPressaoMinima"].setValue(
            eixo8EsquerdoInt.nrPressaoMinima
          );

          this.axisEightDoubleLeftIntForm.controls["nrPressaoMaxima"].setValue(
            eixo8EsquerdoInt.nrPressaoMaxima
          );

          this.axisEightDoubleLeftIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo8EsquerdoInt.nrTemperaturaMaxima);
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public async submitFormDelete(form: FormGroup): Promise<void> {
    this.spinner.show();
    try {
      const values = form.value;
      var post;

      post = {
        veiculo: {
          id: this.veiculoId,
        },
        nrPressaoMinima: values.nrPressaoMinima,
        nrPressaoMaxima: values.nrPressaoMaxima,
        nrTemperaturaMaxima: values.nrTemperaturaMaxima,
        sensor: {
          id: values.cdSensor,
        },
        pneu: null,
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      console.log(post);

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        values.id,
        new VeiculoSensor()["nomeConsultaApiBaseRemove"],
        post
      );

      form.get("cdSensor").setValue("");
      form.get("id").setValue("");

      this.spinner.hide();

      this.handleDelete();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      //this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async submitFormDeleteAll(): Promise<void> {
    this.spinner.show();
    try {
      var estepeArray: any = [];
      var posicoesPneusList: any = [];

      estepeArray.push(this.axisEightDoubleLeftExtForm.value);
      estepeArray.push(this.axisEightDoubleLeftIntForm.value);
      estepeArray.push(this.axisEightDoubleRightExtForm.value);
      estepeArray.push(this.axisEightDoubleRightIntForm.value);

      if (estepeArray.length > 0) {
        estepeArray.forEach((element) => {
          var posicaoPneuResquest = {
            cdPosicaoPneu: element.cdPosicaoPneu,
          };
          posicoesPneusList.push(posicaoPneuResquest);
        });
      }

      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseRemoveAll"],
        post
      );

      this.axisEightDoubleLeftExtForm.get("cdSensor").setValue("");
      this.axisEightDoubleLeftExtForm.get("id").setValue("");
      this.axisEightDoubleLeftIntForm.get("cdSensor").setValue("");
      this.axisEightDoubleLeftIntForm.get("id").setValue("");
      this.axisEightDoubleRightExtForm.get("cdSensor").setValue("");
      this.axisEightDoubleRightExtForm.get("id").setValue("");
      this.axisEightDoubleRightIntForm.get("cdSensor").setValue("");
      this.axisEightDoubleRightIntForm.get("id").setValue("");

      this.spinner.hide();

      this.handleDeleteAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async submitFormAddAll(): Promise<void> {
    var estepeArray: any = [];

      estepeArray.push(this.axisEightDoubleLeftExtForm.value);
      estepeArray.push(this.axisEightDoubleLeftIntForm.value);
      estepeArray.push(this.axisEightDoubleRightExtForm.value);
      estepeArray.push(this.axisEightDoubleRightIntForm.value);

    const posicoesIncompletas = findIncompleteSensorRows(estepeArray);
    if (posicoesIncompletas.length > 0) {
      await alertIncompleteTpmsRows(posicoesIncompletas);
      return;
    }

    if (estepeArray.length > 0 && this.verificarDuplicados(estepeArray)) {
      this.handleItensDuplicados();
      return;
    }

    var posicoesPneusList: any = [];

    estepeArray.forEach((element) => {
      if (element.cdSensor != "") {
        var posicaoPneuResquest = {
          cdPosicaoPneu: element.cdPosicaoPneu,
          cdSensor: element.cdSensor,
          pneu: element.pneu,
          nrPressaoMinima: element.nrPressaoMinima,
          nrPressaoMaxima: element.nrPressaoMaxima,
          nrTemperaturaMaxima: element.nrTemperaturaMaxima,
          idPerfil: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
        posicoesPneusList.push(posicaoPneuResquest);
      }
    });

    if (posicoesPneusList.length === 0) {
      return;
    }

    this.spinner.show();
    try {
      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseAddAll"],
        post
      );

      this.spinner.hide();

      this.handleAddAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }


  verificarDuplicados(axisOneArray: any[]): boolean {
    const seen = new Set();
    for (const item of axisOneArray) {
      if (seen.has(item.cdSensor)) {
        return true; // Retorna true se encontrar um valor duplicado
      } else {
        seen.add(item.cdSensor);
      }
    }
    return false; // Retorna false se não houver valores duplicados
  }

  public async handleItensDuplicados(): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Sensores selecionados estão com duplicidade, por favor corrigir!",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleAddAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 8 vinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDeleteAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 8 desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDelete(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensor desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }
}
